import {Form} from 'antd'
import  * as CryptoJS from 'crypto-js'
export const companyId = 4
/**
 * 多条件分页
 * @param temPage
 * @param pagination
 * @param searchFields
 * @returns {{}}
 */
export const handleSeerchAndPage = (temPage, pagination, searchFields) => {
    if (temPage) {
        temPage--
    } else if (pagination.page) {
        temPage = pagination.page - 1
    } else {
        temPage = 0
    }
    // 构建查询参数
    let search = {}
    Object.keys(searchFields).forEach(key => {
        search[`search.${key}`] = searchFields[key].value ? searchFields[key].value : ((searchFields[key]+'') ? (searchFields[key]+'') : '')
    })
    search.page = temPage
    search.size = 10
    return search
}
/**
 * 构造后台Map
 * @param pram
 * @returns {{}}
 */
export const searchMap = (param) => {
    let search = {}
    Object.keys(param).forEach(key => {
        search[`search.${key}`] = param[key].value ? param[key].value : (param[key] ? param[key] : '')
    })
    return search
}
/**
 * 平行tree结构取ids
 * @param node
 * @returns {Array}
 */
export const getTreeIds = (node) => {
    var ids = []
    for (var i = 0; i < node.length; i++) {
        ids.push(node[i].id.toString())
        ids = ids.concat(getTreeIds(node[i].children))
    }
    return ids
}
/**
 * {xxx：123} to {xxx:{value:123}}
 * @param obj
 * @returns {{}}
 */
export const objToValueObj = (obj) => {
    let target = {}
    obj && Object.keys(obj).forEach(key => {
        target[`${key}`] = {value: obj[`${key}`]}
    })
    return target
}

/**
 * {xxx:{value:123}} to {xxx：123}
 * @param obj
 * @returns {{}}
 * @constructor
 */
export const ValueObjToObj = (obj) => {
    let target = {}
    Object.keys(obj).forEach(key => {
        target[`${key}`] = obj[`${key}`].value
    })
    return target
}

/**
 * 将属性转化为表单可用属性
 * @param obj
 * @returns {{}}
 */
export const objToForm = (obj) => {
    let target = {}
    Object.keys(obj).forEach(key => {
        target[`${key}`] = Form.createFormField({value: obj[`${key}`]})
    })
    return target
}

/**
 * 将回复的树转换为一个列表
 * @param arr,arr
 * @returns
 */
export function getReplyList(children, list, commented) {
    if (!Array.isArray(children)) {
        return
    }
    children.forEach(item => {
        const obj = {...item, commented: commented}
        list.push(obj)
        getReplyList(item.children, list, item.senderUserName)
    })
}

/**
 * 将对象转换为键值对拼接到url里
 */
export function query(data) {
    var queryStr = '';
    for (var [key, value] of Object.entries(data)) {
        if (value === undefined) {
            continue
        }
        queryStr += `&search.${key}=${value}`;
    }
    return queryStr ? queryStr.substring(1) : '';
}

/**
 * 查询参数对象属性添加search
 * @param obj
 * @returns {{}}
 */
export function formatParams(obj){
    let params = {}
    for(let [key,value] of Object.entries(obj)){
        if(value){
            params[`search.${key}`] = value
        } else {
            params[`search.${key}`] = ''
        }
    }
    return params
}

/**
 * 去除掉前台显示的展开图标
 */
export function findChildren(arr){
    for(let i in arr){
        if(!arr[i].children.length){
            arr[i].children='';
        }else{
            findChildren(arr[i].children)
        }
    }
    return arr
}

/**
 * 设置store对象，类似react的setState
 * @param obj
 */
export function setStore(obj,that)  {
    if (Object.prototype.toString.call(obj) === '[object Object]') {
        for (let [key, value] of Object.entries(obj)) {
            that[key] = value
        }
    }
}

/**
 * *@data:字符串 *@key:字符串或byte[]
 * */
export function AESEncrypt(data,key) {
    let AES_KEY = CryptoJS.enc.Utf8.parse(key);
    let sendData = CryptoJS.enc.Utf8.parse(data);
    let encrypted = CryptoJS.AES.encrypt(sendData, AES_KEY,{mode:CryptoJS.mode.ECB,padding:CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/***
 * 文件GET请求下载
 */
export function downLoad (downloadUrl,fileName){
    fetch(downloadUrl, {
        method: 'Get',
        // body: JSON.stringify(fileName),
        credentials: 'include',
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    }).then((response) => {
        response.blob().then(blob => {
            const aLink = document.createElement('a');
            document.body.appendChild(aLink);
            aLink.style.display='none';
            aLink.href = URL.createObjectURL(blob);
            aLink.download = fileName;
            aLink.click();
            document.body.removeChild(aLink);
        });
    }).catch((error) => {
        console.log(error);
    });
}

//防抖
export function deBounce(func, wait) {
    let timeOut = null;
    return function (...args) {
        clearTimeout(timeOut);//一定要清除定时器
        timeOut = setTimeout(() => {
            func(...args);
        }, wait);
    };
}

/**
 * store回显到表单的处理
 * @param obj
 * @returns {{}}
 */
export function createFormItemObj(obj) {
    let target = {}
    for(let[key,value] of Object.entries(obj)){
        target[key] = Form.createFormField({value})
    }
    return target
}

/**
 * store回显到表单的处理（包括error）
 * @param obj
 * @returns {{}}
 */
export function createFormItemObjError(obj) {
    let target = {}
    for(let[key,value] of Object.entries(obj)){
        target[key] = Form.createFormField(value)
    }
    return target
}

export function getPhotoPattern(file) {
    let pattern = new RegExp("^.*?\\.(png|jpg|jpeg|bmp|PNG|JPG|JPEG|BMP)$")
    let name = file.name.substring(file.name.lastIndexOf("."),file.name.length)
    return pattern.test(name)
}

//判断按钮权限，子集显示是否禁用按钮
export function disabledChildBtn(module,name,btn) {
    // let allBtn = appStore.leftMenu.find(item => item.name=== module)  //获取按钮数组列表
    // let btnList = allBtn.children.find(item=>item.name=== name)
    // let list = btnList.children.find(item => item.key=== btn)
    // return !list
}

//判断按钮权限，显示是否禁用按钮
export function disabledBtn(name,btn) {
    // let allBtn = BackendStore.leftMenu.find(item => item.name=== name)  //获取按钮数组列表
    // let btnList = allBtn.children.find(item => item.key=== btn)
    // return !btnList
}

/**
 * 多条件分页、、动态分页数据
 * @param temPage
 * @param pagination
 * @param searchFields
 * @returns {{}}
 */
export const handleSearchAndPage = (temPage, pagination, searchFields) => {
    if (temPage) {
        temPage--
    } else if (pagination.page) {
        temPage = pagination.page - 1
    } else {
        temPage = 0
    }
    // 构建查询参数
    let search = {}
    Object.keys(searchFields).forEach(key => {
        search[`search.${key}`] = searchFields[key].value ? searchFields[key].value : ((searchFields[key]+'') ? (searchFields[key]+'') : '')
    })
    search.page = temPage
    search.size = pagination.pageSize
    return search
}

/**
 * 根据文件过滤
 * @param file
 * @returns {boolean}
 */

export function getPattern(file) {
    let pattern = new RegExp("^.*?\\.(jpg|bmp|png|mp4|wmv|rar|zip|doc|docx|xls|xlsx|JPG|BMP|PNG|MP4|WMV|RAR|ZIP|DOC|DOCX|XLS|XLSX|txt|ppt|pdf|pptx)$")
    let name = file.name.substring(file.name.lastIndexOf("."),file.name.length)
    return pattern.test(name)
}

export function getFileFormat(file) {
    let pattern = new RegExp("^.*?\\.(php|sh|asp|aspx|jsp|html|htm)$")
    let name = file.name.substring(file.name.lastIndexOf("."),file.name.length)
    return pattern.test(name)
}

//清空表单
export const clearForm = (obj) => {
    let target = {}
    Object.keys(obj).forEach(key => {
        target[key] =''
    })
    return target
}

/**
 * 将对象转化为url参数
 */
export function objToUrlParams(data){
    let queryStr = '';
    for (let [key, value] of Object.entries(data)) {
        if (value) {
            queryStr += `&${key}=${value}`;
        }
    }
    return queryStr ? queryStr.substring(1) : '';
}

/**
 * 查询search
 * @param pram
 * @returns {{}}
 */
export const searchs = (param) => {
    let search = {}
    Object.keys(param).forEach(key => {
        search[`search.${key}`] = param[key] ? param[key] : ''
    })
    return search
}

/**
 * 当前时间加一天
 * @param d
 * @returns {string}
 */
export function getBeforeDay(d){
    d = new Date(d);
    d = +d + 1000*60*60*24;
    d = new Date(d);
    let year = d.getFullYear();
    let mon = d.getMonth()+1;
    let day = d.getDate();
    let s = year+"-"+(mon<10?('0'+mon):mon)+"-"+(day<10?('0'+day):day);
    return s;
}

/**
 * 获取url中的参数并转化为对象
 * @param str
 * @returns {{}}
 */
export function getUrlParmas(str) {
    let obj = {}
    str.substring(1).split('&').forEach(item => {
        const arr = item.split('=')
        obj[arr[0]] = arr[1]
    })
    return obj
}

/**
 * 查询参数search形式.（search.xxx）
 * @param searchFields
 * @returns {string}
 * @private
 */
export function _encodeParamToSearch(searchFields ={}) {
    // 构建查询参数
    let search = {}
    Object.keys(searchFields).forEach(key => {
        if (searchFields[key]) {
            search[`search.${key}`] = searchFields[key].value ? searchFields[key].value : ((searchFields[key] + '') ? (searchFields[key] + '') : '')
        }
    })
    const obj = {...search, companyId}
    return Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key] ? obj[key] : '')}`)
        .join('&')
}

//判断按钮权限，子集显示是否禁用按钮
export function disabledChildrenBtn(module,name,childName,btn) {
    // let allBtn = BackendStore.leftMenu.find(item => item.name=== module)  //获取按钮数组列表
    // let btnList = allBtn.children.find(item=>item.name=== name).children.find(i=>i.name=== childName)
    // let list = btnList.children.find(item => item.key=== btn)
    // return !list
}






// WEBPACK FOOTER //
// ./src/utils/Utils.js